import { BlockTitle, Page, Popup } from "framework7-react";

import { FeelingForm } from "@/components/FeelingForm";
import { createPage, PageComponentProps } from "@/factories/createPage";
import { FeelingEnum } from "@/generated/graphql/graphql";
import { usePopupPageReady } from "@/hooks/usePopupPageReady";
import { useUserFeeling } from "@/hooks/useUserFeeling";
import { AppBridgeProvider } from "@/providers/AppBridgeProvider";

export const FeelingEditPage = createPage("FeelingEditPage", PageComponent);

function PageComponent({ pageName, f7route, f7router, ...routeProps }: PageComponentProps) {
  const { getPageProps, isPageReady, swipeHandler } = usePopupPageReady(pageName);

  const feelingKey = f7route.params.feelingKey as FeelingEnum;
  const userFeeling = useUserFeeling(feelingKey);

  return (
    <AppBridgeProvider
      f7route={f7route}
      f7router={f7router}
      isVisible={isPageReady}
      {...routeProps}
    >
      <Popup
        backdrop
        data-component={pageName}
        style={{
          borderRadius: "var(--f7-sheet-border-radius) var(--f7-sheet-border-radius) 0 0",
          top: "calc(var(--f7-navbar-height) + var(--f7-safe-area-top))",
        }}
        {...getPageProps()}
      >
        <Page>
          {swipeHandler}
          <BlockTitle large>{userFeeling?.name} の編集</BlockTitle>
          {userFeeling && (
            <FeelingForm
              userFeeling={userFeeling}
              onCompleted={() => f7router.back()}
            />
          )}
        </Page>
      </Popup>
    </AppBridgeProvider>
  );
}
